module.exports = __webpack_public_path__ + "img/antes_despues_291.3f86017d.png";